import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dgx-skill-standards-segment-status-indicator',
  templateUrl: './skill-standards-segment-status-indicator.component.html',
  styleUrls: ['./skill-standards-segment-status-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkillStandardsSegmentStatusIndicatorComponent {
  @Input() public status: string;
  @Input() public count?: number;

  public i18n = this.translate.instant([
    'SkillStd_Status_NoSegments',
    'SkillStd_Status_UnpublishedSegments',
  ]);

  constructor(private translate: TranslateService) {}

  public statusDisplay(status: string): string {
    let itemStatus: string;

    switch (status) {
      case '1':
        itemStatus = this.i18n.SkillStd_Status_NoSegments;
        break;
      case '2':
        itemStatus = this.i18n.SkillStd_Status_UnpublishedSegments;
        break;
    }

    return itemStatus;
  }
}
